// extracted by mini-css-extract-plugin
export var modal = "_bm-0";